import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ListProps,
} from 'react-admin'

const VideoFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="vimeo_id" alwaysOn />
      <ReferenceInput label="" source="" reference="" allowEmpty>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  )
}

export const ListVideos: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<VideoFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Tipo" source="type" />
        <TextField label="Vimeo ID" source="vimeo_id" />
      </Datagrid>
    </List>
  )
}
